import React from 'react';
import styles from '../../css/form.module.css';
import { RegularPageTemplate } from '../RegularPageTemplate';
import { RegisterForm } from './index';

export function RegisterComposer(): JSX.Element {
  return (
    <RegularPageTemplate>
      <div className="row">
        <div className="col-10 offset-1 col-md-8 offset-md-2 col-lg-6 offset-lg-3">
          <RegisterForm title="Чтобы продавать музыку, нужно войти в систему и заполнить предложенную анкету" />
        </div>
      </div>
    </RegularPageTemplate>
  );
}